// src/components/PageWrapper.js
import React from "react";

export default function PageWrapper({ children }) {
  return (
    <div style={{
      paddingTop: "90px",        // Adjust if your navbar is taller/shorter
      minHeight: "100vh",
      margin: "auto",
      width: "70%",             // 100% is safest for mobile
      maxWidth: "100vw",         // Ensures no horizontal overflow
      boxSizing: "border-box",
      overflowX: "hidden",       // Prevents sideways scrolling
      background: "inherit"      // Lets your main site bg show through
    }}>
      {children}
    </div>
  );
}
